import { useRestClient } from '@/contexts/QueryProvider'
import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { DagsterAppCard } from './DagsterAppCard'
import { EmptyState } from '@/components/ui/EmptyState'
// import { dagsterAppsMockData } from './dagsterAppsMockData'

export function DagsterApplicationsPage() {
  const { getDagsterApiGetDagsterApps } = useRestClient()

  // type DagsterApp = RestSchemas['Messages.Dagster.DagsterApplication']
  const { data: dagsterApps } = getDagsterApiGetDagsterApps.useSuspenseQuery(undefined, {
    // select: () => dagsterAppsMockData,
  })

  return (
    <SectionLayout>
      <SectionContainer title="Dagster applications">
        {dagsterApps.length > 0 ? (
          <div
            className="padded grid w-full grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-5 pb-5"
            style={{ maxHeight: '85vh' }}
          >
            {dagsterApps?.map((app) => <DagsterAppCard key={app.applicationId} application={app} />)}
          </div>
        ) : (
          <EmptyState title="No Dagster applications found." />
        )}
      </SectionContainer>
    </SectionLayout>
  )
}
